import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class OccupationOfLanePlacementConstructionObjectsStatementForm extends AppForm {
  constructor() {
    super({
      objectPlacementStatementType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }
}
